"use client";

import { WlkpCompanyEmployerBasicRegistrationDto } from "@entities/employer";
import { DetailItem } from "@shared/ui";

export function WlkpCompanyEmployerBasicDetails({ basic }: { basic: WlkpCompanyEmployerBasicRegistrationDto }) {
  if (!basic) return <></>;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
      <div className="col-span-full">
        <DetailItem label="Industri" value={String(basic.industry?.label || "-")} />
      </div>
      <div>
        <DetailItem label="Nama PIC" value={basic.pic_name || "-"} />
      </div>
      <div>
        <DetailItem label="NIK PIC" value={basic.pic_id_number || "-"} />
      </div>
      <div>
        <DetailItem label="Email PIC" value={basic.pic_email || "-"} />
      </div>
      <div>
        <DetailItem label="Nomor telepon PIC" value={basic.pic_phone ? `+62 ${basic.pic_phone}` : "-"} />
      </div>
    </div>
  );
}
